const initialState = {
  data: [],
};
  
const udzialyKontaAllReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_UDZIALY_KONTA_ALL':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default udzialyKontaAllReducer;